import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import HelmetComponent from "../../components/shared/Helmet";
import Player from "../../components/shared/Player";
import Rail from "../../components/shared/Rail";
import RelatedObjectsSlider from "../../components/shared/RelatedObjectsSlider";
import RelatedTopicList from "../../components/shared/RelatedTopicList";
import { compose, bindActionCreators } from "redux";
import { returnDate, sanitizeAndProcessHtml } from "../../util/commonFunctions";
import PlayerOverlay from "../../components/common/playerOverlay";
import { getEnv } from '../../../helpers/env';
import {
  getHomePageSection,
  getAutoRail,
  getRelatedRail,
  hideLoader,
  showLoader,
  getDetailDataInitialLoad,
  getRelatedDetailDataInitialLoad,
  setRailData,
  removeDetailPageData,
  getLiveStreamData,
  setSignupModalStatus
} from "../../actions";
import {
  getParameterByName,
  IsEmpty,
  convertToSlug,
  appendFollowStatus,
  followButtonClicked,
  unFollowButtonClicked,
  generateStructuredData
} from "../../util/commonFunctions";
import pageNotFound404 from "../pageNotFound404";


let vodTimer = 15;
let showLocalVod = null;

class Detail extends Component {
  state = {
    railData: null,
    railType: null,
    showVod: null,
    currentVodId: null,
    originalRail: null,
    showVodNumber: null,
    enableOverlay: false,
    title: null,
    vodUrl: null,
    startPosition: 0,
    reachSameVideo: false,
    sectionId: null,
    currentPlayingIndex: 0,
    changeVideoPlaylist: false,
    clickedVideoPlaylist: false,
    initialRenderingDone: false,
    signinPopupCanAppear: true,
    descHeight: 100,
    structuredData: null,
    showTranscript: false,
  };

  toggleTranscript = () => {
    this.setState({
      showTranscript: !this.state.showTranscript,
    })
  };

  enableOverlayFun = () => {
    this.setState({
      enableOverlay: true
    });
    if (this.state.signinPopupCanAppear && !this.props.signUpModalStatus) {
      this.openSigninModalPopup("signin");
      this.setState({
        signinPopupCanAppear: false
      });
    }
  };

  openSigninModalPopup = (requestedForm) => {
    this.props.setSignupModalStatus(true, requestedForm);
  };

  filterVod = (data, id) => {
    return data.filter(value => {
      value.islive = false;
      if (value.id == id) {
        value.islive = true;
        showLocalVod = value;
        return false;
      }
      return true;
    });
  };

  setStateData = () => {
    if (IsEmpty(this.props.detail.railData)) {
      return false;
    }
    const railFilterData = this.filterVod(
      this.props.detail.railData,
      this.props.detail.videoId
    );
    railFilterData.unshift(showLocalVod);
    const structuredData = generateStructuredData(railFilterData);
    structuredData && this.setState({
      structuredData: `{
        "@context":"https://schema.org",
        "@graph": [${structuredData}]
      }`
    });
    this.setState({
      railData: railFilterData,
      showVod: showLocalVod,
      vodUrl: showLocalVod.videoUrl,
      currentVodId: this.props.detail.videoId,
      originalRail: railFilterData,
      railType: "latest_rail",
      theme: "DARK",
      title: this.props.detail.detailHomeSectionData
        ? "Up Next"
        : "Related Videos",
      sectionId:
        this.props.detail.detailHomeSectionData &&
        this.props.detail.detailHomeSectionData.id,
      initialRenderingDone: true,
    }, () => {
      this.setSeriesFollowStatus(); //series follow status append
    });
  };

  setSeriesFollowStatus() {
    if (localStorage.getItem("token")) {
      if (this.state.showVod.eventSeries && !IsEmpty(this.state.showVod.eventSeries)) {
        appendFollowStatus(this.appendFollowSeriesStatusRespHandler, localStorage.getItem("token"), this.state.showVod.eventSeries, false, false, false, true);
      }
    }
  }

  setPlayerAndRail = async (rail, videoId) => {
    switch (true) {
      case rail.railType && rail.railType.toLowerCase() == "custom":
        this.props.setRailData(rail.contentList, videoId);
        break;
      case rail.railType && rail.railType.toLowerCase() == "auto":
        const { getAutoRail, currentLanguage } = this.props;
        let idOfTopicOrSeries = null;
        // `rail.topic` object can correspond to either a taxonomy or a series
        // yes, it is badly named, blame the previous developers
        if (rail.topic){
          idOfTopicOrSeries = rail.topic.id;
        }
        await getAutoRail(rail.numberOfVODs, rail.subType.toLowerCase(), idOfTopicOrSeries, videoId, currentLanguage);
        break;
      default:
        break;
    }
  };

  componentWillUnmount = () => {
    this.props.removeDetailPageData();
  };

  componentDidUpdate = () => {
    // window.addEventListener('load', this.handleLoad);
    // const videoId = getParameterByName("videoId");
    // if (this.state.currentVodId && videoId != this.state.currentVodId) {
    //   setTimeout(this.handleLoad(), 3000);
    //   // this.handleLoad();
    // }
  }

  componentDidMount = async () => {
    let sectionId = getParameterByName("sectionId");
    let videoId = getParameterByName("videoId");

    if (!this.props.liveStreamData) {
      this.props.getLiveStreamData();
    }
    if (this.props.detail.videoId !== videoId) {
      if (!IsEmpty(sectionId) && this.props.detail.detailHomeSectionData) {
        const { getHomePageSection, currentLanguage } = this.props;
        await getHomePageSection({ sectionId, language: currentLanguage });
        this.setPlayerAndRail(this.props.detail.detailHomeSectionData, videoId);
      } else {
        const { getRelatedRail, currentLanguage } = this.props;
        await getRelatedRail(videoId, currentLanguage);
      }
    }
    if (localStorage.getItem("lastVideoSeek")) {
      this.setState({
        startPosition: localStorage.getItem("lastVideoSeek")
      });
    }
    localStorage.setItem("lastVideoSeek", "");
    setTimeout(
      () => this.handleLoad(),
      500
    );
  };

  appendFollowSeriesStatusRespHandler = (response, error) => {
    this.setState(prevState => ({
      showVod: {
        ...prevState.showVod,
        eventSeries: response
      }
    }))
  }

  handleLoad = () => {
    let descHgt = document.querySelector('.video-info-toggle');
    if (descHgt?.scrollHeight) {
      this.setState({
        descHeight: descHgt.scrollHeight
      });
    }
  }

  shouldComponentUpdate = (nextProps, state) => {
    const videoId = getParameterByName("videoId");
    if (state.currentVodId && videoId != state.currentVodId) {  //condition : playing video is changed
      this.filterVod(state.originalRail, videoId);
      this.setState(prevState => {
        return {
          showVod: showLocalVod,
          vodUrl: showLocalVod.videoUrl,
          enableOverlay: false,
          startPosition: prevState.changeVideoPlaylist
            ? prevState.currentPlayingIndex + 1
            : prevState.currentPlayingIndex,
          currentVodId: videoId,
          currentPlayingIndex: prevState.changeVideoPlaylist
            ? prevState.currentPlayingIndex + 1
            : prevState.currentPlayingIndex,
          changeVideoPlaylist: false,
          clickedVideoPlaylist: false,
          signinPopupCanAppear: true
        };
      }, () => {
        this.setSeriesFollowStatus();
      });
      setTimeout(
        () => this.handleLoad(),
        500
      );
    }
    return true;
  };

  changeVodDetails = index => {
    this.setState(
      {
        changeVideoPlaylist: true
      },
      () => {
        if (this.state.railData.length > index) {
          this.props.history.push(
            !IsEmpty(this.state.sectionId)
              ? "/media/" +
              convertToSlug(this.state.railData[parseInt(index)].title) +
              "?videoId=" +
              this.state.railData[parseInt(index)].id +
              "&sectionId=" +
              this.state.sectionId
              : "/media/" +
              convertToSlug(this.state.railData[parseInt(index)].title) +
              "?videoId=" +
              this.state.railData[parseInt(index)].id
          );
        }
      }
    );
  };

  getIndexOfClicked = (event, index) => {
    this.setState(
      {
        clickedVideoPlaylist: true,
        currentPlayingIndex: index,
        descHeight: 100
      },
      () => {
        if (this.state.railData.length > index) {
          this.props.history.push(
            !IsEmpty(this.state.sectionId)
              ? "/media/" +
              convertToSlug(this.state.railData[parseInt(index)].title) +
              "?videoId=" +
              this.state.railData[parseInt(index)].id +
              "&sectionId=" +
              this.state.sectionId
              : "/media/" +
              convertToSlug(this.state.railData[parseInt(index)].title) +
              "?videoId=" +
              this.state.railData[parseInt(index)].id
          );
        }
      }
    );
  };

  toggleText = () => {
    let descHgt = document.querySelector('.video-info-toggle');
    let infoHeight = descHgt.scrollHeight;
    let btnText = document.querySelector(".toggle-text");
    if (btnText.innerHTML === "show more") {
      btnText.innerHTML = "show less";
    } else {
      btnText.innerHTML = "show more";
    }
    descHgt.style.setProperty('--max-height', infoHeight + 'px');
    descHgt.classList.toggle("is-visible");
  }

  followObject = (objectId, objectType) => {
    const isLoggedin = !IsEmpty(localStorage.getItem("token"))
    if (isLoggedin) {
      if (objectType == "company") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), objectId);
      } else if (objectType == "expert") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
      } else if (objectType == "topic") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, objectId);
      } else if (objectType == "series") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, null, null, objectId);
      }
    } else {
      this.openSigninModalPopup("signin");
    }
  }

  unFollowObject = (objectId, objectType) => {
    if (objectType == "company") {
      unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), objectId);
    } else if (objectType == "expert") {
      unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
    } else if (objectType == "topic") {
      unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, objectId);
    } else if (objectType == "series") {
      unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, null, null, objectId);
    }
  }

  followButtonClickedRespHandler = (response, error) => {
    this.updateFollowBtnStatus(response.objectId, response.objectType);
  }

  unFollowButtonClickedRespHandler = (response, error) => {
    this.updateFollowBtnStatus(response.objectId, response.objectType);
  }

  updateFollowBtnStatus = (objectId, objectType) => {
    let updated_event_series = {};
    updated_event_series = this.state.showVod.eventSeries;
    updated_event_series.isFollowed = !updated_event_series.isFollowed;
    this.setState(prevState => ({
      showVod: {
        ...prevState.showVod,
        eventSeries: updated_event_series
      }
    }))
  }

  
  render = () => {
    return (
      <React.Fragment>
        {(!IsEmpty(this.props.detail.playingVideo) ||
          !IsEmpty(this.state.showVod)) && (
            <HelmetComponent
              title={
                this.state.showVod
                  ? this.state.showVod.title + " on ausbiz"
                  : this.props.detail.playingVideo.title + " on ausbiz"
              }
              subject={
                this.state.showVod
                  ? this.state.showVod.topic.name
                  : this.props.detail.playingVideo.topic.name
              }
              description={
                this.state.showVod
                  ? this.state.showVod.desc
                  : this.props.detail.playingVideo.desc
              }
              customDescription={
                this.state.showVod
                  ? this.state.showVod.desc
                  : this.props.detail.playingVideo.desc
              }
              keywords={
                this.state.showVod
                  ? this.state.showVod.tag
                  : this.props.detail.playingVideo.tag
              }
              thumbnailImage={
                this.state.showVod
                  ? this.state.showVod.imageUrl
                  : this.props.detail.playingVideo.imageUrl
              }
              jsonLd={true}
              jsonLdObject={
                this.state.showVod
                  ? this.state.showVod
                  : this.props.detail.playingVideo
              }
              noIndex="false"
              canonicalUrl={getEnv('BASE_URL') + "/media" + `/${convertToSlug(this.state.showVod
                ? this.state.showVod.title
                : this.props.detail.playingVideo.title)}` + 
                `?videoId=${this.state.showVod ? this.state.showVod.id : this.props.detail.playingVideo.id}`
              }
              structuredData={this.state.structuredData}
              transcriptData={this.state.showVod?.transcript}
            />
          )}
        {!this.state.initialRenderingDone ? (
          this.setStateData()
        ) : (
          <React.Fragment>
            <div
              className={!this.props.userProfile ? "player nonLogin" : "player"}
            >
              <div className="container">
                <div className="row">
                  <div className="col-md-8 no-gutter-col">
                    {this.state.vodUrl && (
                      <React.Fragment>
                        <Player
                          playlist={this.state.railData}
                          videoUrl={this.state.vodUrl}
                          currentVodId={this.state.currentVodId}
                          playerTimeout={
                            (this.props.liveStreamData && parseInt(this.props.liveStreamData.vedioFreeTimer)) || vodTimer
                          }
                          showVod={this.state.showVod && this.state.showVod}
                          enableOverlayFun={this.enableOverlayFun}
                          token={this.props.token}
                          changeVodDetails={this.changeVodDetails}
                          playVideo={true}
                          userProfile={this.props.userProfile}
                          startPosition={this.state.startPosition}
                          currentPlayingIndex={this.state.currentPlayingIndex}
                        />
                        {this.state.enableOverlay && <PlayerOverlay />}
                      </React.Fragment>
                    )}
                  </div>
                  <div className="col-md-4 showDetails vodDetails">
                    {this.state.showVod && (
                      <React.Fragment>
                        <h1>
                          {this.state.showVod.title}
                        </h1>

                        {this.state.showVod?.subtitle && !IsEmpty(this.state.showVod?.subtitle) &&
                          <h2>
                            {this.state.showVod.subtitle}
                          </h2>
                        }

                        <span className="video-time">
                          {returnDate(this.state.showVod.upload_time)}
                        </span>

                        {this.state.showVod.eventSeries && !IsEmpty(this.state.showVod.eventSeries) &&
                          <div className="title-with-pic">
                            <Link
                              to={{
                                pathname: `/series/${convertToSlug(this.state.showVod.eventSeries.name)}?seriesID=${this.state.showVod.eventSeries.id}`,
                              }}
                            >
                              <div className="circle-img">
                                {!IsEmpty(this.state.showVod.eventSeries.url) &&
                                  <img src={this.state.showVod.eventSeries.url} alt="Ausbiz Series" />
                                }
                                {IsEmpty(this.state.showVod.eventSeries.url) &&
                                  <img src="/assets/ausbiz_series_logo.png" alt="Ausbiz Series" />
                                }
                              </div>
                              <span>
                                {this.state.showVod.eventSeries.name} <br />
                                <small>Series</small>
                              </span>
                            </Link>
                            {!this.state.showVod.eventSeries.isFollowed &&
                              <div className="tick-icon" onClick={() => this.followObject(this.state.showVod.eventSeries.id, "series")}></div>
                            }
                            {this.state.showVod.eventSeries.isFollowed &&
                              <div className="tick-icon active" onClick={() => this.unFollowObject(this.state.showVod.eventSeries.id, "series")}></div>
                            }
                          </div>
                        }

                        <div className={this.state.descHeight > 100 ? "video-info-toggle video-info-active" : "video-info-toggle"}>
                            <p className="description" dangerouslySetInnerHTML={{ __html: sanitizeAndProcessHtml(this.state.showVod.desc) }}></p>
                        </div>
                        {this.state.descHeight > 100 && <div className="toggle-margin"><span className="toggle-text" onClick={this.toggleText}>show more</span></div>}
                        {this.state.showVod.transcript &&
                          <div className="transcript-container">
                            <button className="transcript-button" onClick={this.toggleTranscript}>{this.state.showTranscript ? "Hide Transcript" : "Show Transcript"}</button>
                            <article className={`${this.state.showTranscript ? "transcript-content" : "hide"}`}><h2 className="hide">{this.state.showVod.title}</h2><h3 className="transcript-label">Transcript : </h3><p className="description" dangerouslySetInnerHTML={{ __html: sanitizeAndProcessHtml(this.state.showVod.transcript) }}></p></article>
                          </div>
                        }
                        <RelatedTopicList
                          data={this.state.showVod ? this.state.showVod : []}
                          openSigninModalPopup={this.openSigninModalPopup}
                        />
                      </React.Fragment>
                    )}
                  </div>
                </div>
                <RelatedObjectsSlider
                  data={this.state.showVod ? this.state.showVod : []}
                  openSigninModalPopup={this.openSigninModalPopup}
                />
              </div>
            </div>
            {this.state.railData && (
              <Rail
                railType={this.state.railType ? this.state.railType : ""}
                data={this.state.railData ? this.state.railData : []}
                title={this.state.title ? this.state.title : ""}
                railId={this.state.sectionId ? this.state.sectionId : ""}
                showSeeAll={false}
                startPosition={this.state.startPosition}
                theme={this.state.theme}
                getIndexOfClicked={this.getIndexOfClicked}
              />
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };
}

function mapStateToProps(state) {
  return {
    token: state.auth.token,
    detail: state.detail,
    userProfile: state.auth.userProfile,
    liveStreamData: state.home.liveStreamData,
    signUpModalStatus: state.signup.signUpModalStatus,
    currentLanguage: state.language.currentLanguage
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getHomePageSection,
      getAutoRail,
      getRelatedRail,
      showLoader,
      hideLoader,
      setRailData,
      removeDetailPageData,
      getLiveStreamData,
      setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm))
    },
    dispatch
  );
}

function loadData(store, match, query) {
  const currentLanguage = store.getState().language.currentLanguage;
  let initialLoadData = query.sectionId
    ? getDetailDataInitialLoad(query.videoId, query.sectionId, currentLanguage)
    : getRelatedDetailDataInitialLoad(query.videoId, currentLanguage);
  let actionArray = [store.dispatch(initialLoadData)];
  return actionArray;
}

export default {
  loadData,
  component: compose(connect(mapStateToProps, mapDispatchToProps))(Detail)
};
